import request from '@/router/axios';

const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'false' ? '/wage' : '/wage'

//根据代码集id获取代码集
export function getSalaryTemplatelList(obj) {
  return request({
    url: urlPrefix + '/salaryTemplate/queryListPageQuery',
    method: 'post',
    data: obj,
  });
}
export function comRequest(method,templateName,obj ){
  let  url = urlPrefix+'/'+templateName ;
  if(method === 'post'){
    obj.id = null ;
    return request({
      url: url,
      method: 'post',
      data: obj
    })
  }else if(method === 'get'){
    return request({
      url: url+"/"+obj,
      method: 'get',
    })
  }else if(method === 'put'){
    return request({
      url: url+"/"+obj.id+"/"+obj.isInit,
      method: 'put',
      data: obj
    })
  }else if(method === 'delete'){
    return request({
      url: url+"/"+obj,
      method: 'delete'
    })
  } else if(method === 'page'){
    return request({
      url: url+"/list-page",
      method: 'post',
      data: obj
    })
  }
  console.log("类型错误");
}
//分页查询模板信息
export function getTemplateList(obj) {
  return request({
    url: urlPrefix + '/salaryTemplate/queryListPageQuery',
    method: 'post',
    data:obj
  })
}

//保存模板信息
export function saveTemplateInfo(obj){
  return request({
    url: urlPrefix+'/salaryTemplate/templateInfo',
    method: 'post',
    data: obj
  })
}

//修改模板信息
export function editTemplateInfo(obj){
  return request({
    url: urlPrefix+'/salaryTemplate/templateInfo',
    method: 'put',
    data: obj
  })
}

//删除模板信息
export function deleteTemplateInfo(ids){
  return request({
    url: urlPrefix+'/salaryTemplate/templateInfo',
    method: 'delete',
    params: {ids: ids}
  })
}

// 获取代码集合
export function getCodeItemList(id){
  return request({
    url: urlPrefix+'/salaryTemplate/codeItemList',
    method:'get',
    params: {codeSetId: id}
  })
}

//保存模板项
export function saveTemplate(form){
  return request({
    url: urlPrefix+'/templateItem/templateDetail',
    method: 'post',
    data: form
  })
}

//根据模板id，cusid获取模板项
export function getTemplateItemList(templateId) {
  return request({
    url: urlPrefix + '/templateItem/templateDetail',
    method: 'get',
    params: {
      templateId: templateId,
    }
  })
}
//根据模板id，cusid获取模板项
export function getColumnData(templateId) {
  return request({
    url: urlPrefix + '/templateItem/getColumnData',
    method: 'get',
    params: {
      templateId: templateId,
    }
  })
}

export function getTableData(templateId) {
  return request({
    url: urlPrefix + '/templateItem/getTableData',
    method: 'get',
    params: {
      templateId: templateId,
    }
  })
}
//根据模板id，cusid获取工资单模板
export function getPayrollItemList(templateId) {
  return request({
    url: urlPrefix + '/templateItem/getPayrollItemList',
    method: 'get',
    params: {
      templateId: templateId,
    }
  })
}
export function getItemData() {
  return request({
    url: urlPrefix + '/templateItem/getItemData',
    method: 'get',

  })
}
export function checkTemplateName(name) {
  return request({
    url: urlPrefix + '/salaryTemplate/checkTemplateName',
    method: 'get',
    params: {
      name: name,
    }
  })
}
//批量修改代码集状态
export function changeTemplateStatus(obj){
  return request({
    url: urlPrefix + '/salaryTemplate/changeTemplateStatus',
    method: 'post',
    data: obj
  })
}
export function getPayrollData(obj){
  return request({
    url: urlPrefix + '/salaryTemplate/getPayrollData',
    method: 'get',
  })
}
//获取工作单空模板
export function getPayrollDataNull(obj){
  return request({
    url: urlPrefix + '/salaryTemplate/getPayrollDataNull',
    method: 'get',
  })
}

//删除工作单
export function deletePayroll(obj){
  return request({
    url: urlPrefix + '/salaryTemplate/deletePayroll/'+obj,
    method: 'get',
  })
}

export function getChooseDatas(obj){
  return request({
    url: urlPrefix + '/salaryTemplate/getChooseDatas/'+obj,
    method: 'get',
  })
}

export function getPayrollLists(){
  return request({
    url: urlPrefix + '/salaryTemplate/getPayrollLists',
    method: 'get',
  })
}

export function getChooseLists(obj){
  return request({
    url: urlPrefix + '/salaryTemplate/getChooseLists/'+obj,
    method: 'get',
  })
}
//保存工资单数据组
export function savePayrollDatas(obj){
  return request({
    url: urlPrefix + '/salaryTemplate/savePayrollDatas',
    method: 'post',
    data: obj
  })
}

//查询薪资分类tabs信息
export function getSalaryTabs(obj){
  return request({
    url: urlPrefix + '/salaryHistory/getSalaryTabs',
    method: 'post',
    data: obj,
  })
}
export function saveWageItemColumns(obj){
  return request({
    url: urlPrefix + '/wagebatchdetail/saveWageItemColumns',
    method: 'post',
    data: obj,
  })
}

export function checkItemName(obj){
  return request({
    url: urlPrefix + '/salaryTemplate/checkItemName',
    method: 'post',
    data: obj,
  })
}


